import { render, staticRenderFns } from "./ModalRingkasan.vue?vue&type=template&id=7524634b&scoped=true"
import script from "./ModalRingkasan.vue?vue&type=script&lang=js"
export * from "./ModalRingkasan.vue?vue&type=script&lang=js"
import style0 from "./ModalRingkasan.vue?vue&type=style&index=0&id=7524634b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524634b",
  null
  
)

export default component.exports